// Free-text input with a browser-native `<datalist>` suggestion list.
// Used where the value isn't strictly bounded but we still want quick
// picks from a catalog (material units, shipping units, etc.).
import { useId } from "react";
import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

type Props = {
  value: string;
  options: readonly string[];
  onChange: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

export function ManufacturingDatalistInput({
  value,
  options,
  onChange,
  placeholder,
  disabled,
  className,
}: Props) {
  const listId = useId();
  return (
    <>
      <input
        type="text"
        className={`${inputClass} ${className ?? ""}`}
        value={value}
        list={listId}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      <datalist id={listId}>
        {options.map((option) => (
          <option key={option} value={option} />
        ))}
      </datalist>
    </>
  );
}
